import { formatClock } from "../../../shared/venueZoneFormatting";

export const MINUTE_OPTIONS = Array.from({ length: 1440 / 15 }, (_, i) => i * 15);

export const minutesToLabel = (minute) => {
  const m = Number.isInteger(minute) ? minute : 0;
  return formatClock(Math.floor(m / 60), m % 60);
};
